import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: calc(90vh - 130px);
	max-height: 600px;

	/* necessary !important because lib apply styles inline */
	.pdf-page {
		background-color: #e6e6e6 !important;
	}

	canvas {
		margin: 0 auto;
		width: 100% !important;
		max-width: 676px !important;
		height: auto !important;
		object-fit: cover !important;
	}
`;

export const PDFContainer = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const AreaButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 1rem;
	margin: 1rem 0 0 0;
	flex-shrink: 0;
`;
